import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import ScrollReset from "./hooks/ScrollReset";
import MouseLight from "./hooks/event/MouseLight";
import { useEffect, useRef } from "react";
import AssemblyRoutes from "./routes/AssemblyRoutes";

function App() {
  const velocity = useRef(0);
  const animationFrameId = useRef(null);
  useEffect(() => {
    const scrollFactor = 3;
    const friction = 0.9; // 摩擦係数（0.9〜0.98くらいが自然）

    const handleWheel = (e) => {
      e.preventDefault();

      // スクロール量を加算（制限は後で）
      velocity.current += e.deltaY * scrollFactor;
      // 制限（最大速度を決める）
      velocity.current = Math.max(-250, Math.min(250, velocity.current));

      if (!animationFrameId.current) {
        animateScroll();
      }
    };

    const animateScroll = () => {
      if (Math.abs(velocity.current) < 0.1) {
        velocity.current = 0;
        animationFrameId.current = null;
        return; // 速度がほぼゼロなら停止
      }

      // スクロール実行（window.scrollByは相対移動）
      window.scrollBy({
        top: velocity.current,
        behavior: "auto", // イージングは自分でやるから自動はオフ
      });

      // 減衰（摩擦で速度を減らす）
      velocity.current *= friction;

      animationFrameId.current = requestAnimationFrame(animateScroll);
    };

    // スクロールの無効化（既存のブラウザ挙動抑制）
    document.body.style.overflow = "hidden";
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("wheel", handleWheel);

      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, []);
  return (
    <div>
      <Router>
        <Header />
        <ScrollReset />
        <AssemblyRoutes />
      </Router>
    </div>
  );
}

export default App;
